// @flow strict
import * as React from 'react'
import { type ContentfulNode } from '@mondough/contentful'
import BusinessBankingCTABanner from '../../components/bespoke/BusinessBankingCTABanner'

export const renderBusinesssBankingCTABanner = (node: ContentfulNode) => {
  return <BusinessBankingCTABanner />
}
